<template>
  <!-- Modal -->
  <!-- <div class="modal fade" :id="modal_id" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">-->
  <div class="modal fade" :id="modal_id">
    <div :class="size" class="modal-dialog modal-dialog-centered"
         style="min-height: 100%;
              min-width: 100%;
              padding: 0;
              margin: 0;">
      <div class="modal-content" style="min-height: 100%;min-width: 100%; border-radius: 0; border: none;">
        <div v-if="header" :style="style_header" class="modal-header cursor-default">
          <h5 class="modal-title px-2" style="display: flow-root;">
            <span>
                <i :class='icon' class="mr-2"></i>
            </span>
            <span>
              {{ modal_header }}
            </span>
          </h5>
          <button type="button" class="close pr-4" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" :class="class_body">
          <slot name="body"></slot>
        </div>
        <div v-if="footer" class="modal-footer">
          <slot name="footer">
          <!--<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>-->
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalMobileDefault",
  props: [
      'modal_id',
      'size',
      'header',
      'class_body',
      'style_header',
      'modal_header',
      'icon',
      'footer'
  ]
}
</script>

<style scoped>

</style>